import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class XpService {
  authentication: string

  constructor(private http: HttpClient) { }

  getPageConfig(location: string) {
    const w = window.innerHeight + ''
    const h = window.innerWidth + ''
    return this.http.get(location, { params: new HttpParams().set('w', w).set('h', h) })
  }
  getArticles() {
    return this.http.get(window.location.href)
  }
  invite(service, params) {
    return this.http.get(service, { params: new HttpParams().set('id', params.id).set('part', params.part) });
  }
  verify(service, params) {
    return this.http.get(service, { params: new HttpParams().set('code', params.code) });
  }
  login(service, params) {
    return this.http.post(service, params);
  }
  logout(service) {
    return this.http.get(service);
  }
}
